import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InfoboxService } from '@/common/infobox/infobox.service';
import { DataBagService } from '@/common/data-bag.service';
import { Kind, Note } from '../note.model';
import { TableName } from '@/common/enums/TableName';

interface DialogData {
	kinds: Kind[];
	note: Note;
	resId: number;
	editable: boolean;
	tableName: TableName;
}

@Component({
	selector: 'app-note-dialog',
	templateUrl: './note-dialog.component.html',
	styleUrls: ['./note-dialog.component.scss'],
})
export class NoteDialogComponent implements OnInit {
	noteText = '';
	uploadedMultimedia = [];
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: DialogData,
		public dialogRef: MatDialogRef<any>,
		private readonly infobox: InfoboxService,
		private readonly bag: DataBagService,
	) {}

	ngOnInit(): void {
		if (!this.data.note?.content || !this.data.note.multimedia) {
			return;
		}
		this.uploadedMultimedia = this.data.note.multimedia;
		this.noteText = this.data.note.content;
	}

	uploadFile(event): void {
		Array.from(event.target.files).forEach((file: File) => {
			this.bag.upload('/multimedia/file/', file, (result, error) => {
				this.uploadedMultimedia.push(result);
			});
		});
	}

	deleteImage(index): void {
		this.uploadedMultimedia.splice(index, 1);
	}

	saveNote(): void {
		if (this.noteText === '') {
			this.infobox.error('Notatka musi zawierać treść');
			return;
		}
		const kinds = [];
		this.data.kinds.map((item) => {
			if (item.isChecked) {
				kinds.push(item);
			}
		});
		const dataToSend = {
			content: this.noteText,
			hidden: false,
			tableId: this.data.resId,
			table_name: this.data.tableName,
			multimedia: this.uploadedMultimedia.map((img) => img.id),
			task: null,
			kinds: kinds.map((img) => img.id),
		} as Note;
		this.dialogRef.close(dataToSend);
	}
}
